/* eslint-disable import/prefer-default-export */
import * as React from "react";
import { LinkContext } from "@components";

import selectors from "./selectors";

const { useContext } = React;

export interface BreadcrumbsItem {
  text: string;
  url: string;
  name: string;
}

interface BreadcrumbsProps {
  /** the links to be shown within the breadcrumbs list */
  items: BreadcrumbsItem[];
  title: string;
}

/**
 * A horizontal list of breadcrumb links
 */
export function Breadcrumbs({ items, title }: BreadcrumbsProps) {
  const LinkElement = useContext(LinkContext);
  return (
    <ul className="flex justify-start overflow-hidden">
      {items?.length &&
        items.map(({ text, url }) => (
          <li key={text} className="mr-2 leading-8 truncate opacity-70">
            {url ? (
              <LinkElement href={url} data-testid={selectors.breadcrumbLink}>
                {text}
              </LinkElement>
            ) : (
              text
            )}
          </li>
        ))}
      <li className="mr-2 leading-8 opacity-70">{` / `}</li>
      <li className="mr-2 leading-8 truncate">{`${title}`}</li>
    </ul>
  );
}
